var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.selected)?_c('toolbar-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.selected.length != 0),expression:"selected.length != 0"}],attrs:{"icon":"mdi-folder-remove","tooltip":"Delete folder","color":"error","button":{ disabled: _vm.selected.length < 1 }},on:{"click":_vm.onDeleteSelectedFolders}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }